import PayoutManagement from './components/PayoutManagement';

const DriversPage = () => {
  return (
    <div className="space-y-12 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <div className="flex flex-col gap-1">
        <h1 className="text-3xl font-extrabold text-[#121415] tracking-tight">Driver Settlements</h1>
        <p className="text-[#909090] font-medium">Process pending transfers and audit driver payout history.</p>
      </div>

      <PayoutManagement />
    </div>
  );
};

export default DriversPage;
